import { useState, useEffect } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Button,
	FormControlLabel,
	Checkbox,
	Alert,
	Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Loading } from "../../components/common/Loading";
import { deleteAccount } from "../../services/api";

export default function DeleteAccountModal({ isOpen, onClose }) {
	const { t } = useTranslation();

	const [confirmed, setConfirmed] = useState(false);
	const [isPending, setIsPending] = useState(false);
	const [isSuccess, setIsSuccess] = useState(false);

	useEffect(() => {
		if (isOpen) {
			setConfirmed(false);
			setIsPending(false);
			setIsSuccess(false);
		}
	}, [isOpen]);

	const handleDeleteAccount = async () => {
		setIsPending(true);
		try {
			await deleteAccount();

			setIsSuccess(true);

			setTimeout(() => {
				localStorage.removeItem("authToken");
				window.location.href = "/login";
			}, 3000);
		} catch (err) {
			console.error(err);
		} finally {
			setIsPending(false);
		}
	};

	return (
		<Dialog
			open={isOpen}
			onClose={onClose}
			aria-labelledby="delete-account-title"
			aria-describedby="delete-account-description"
			maxWidth="xs"
			fullWidth
		>
			{isPending && <Loading />}

			{isSuccess && (
				<Box
					sx={{
						position: "fixed",
						top: "100px",
						left: "50%",
						transform: "translateX(-50%)",
						zIndex: 5,
					}}
				>
					<Alert severity="success">
						{t("accountDeletedSuccessfully")}
					</Alert>
				</Box>
			)}

			<DialogTitle id="delete-account-title" color="error">
				{t("deleteAccount")}
			</DialogTitle>

			<DialogContent>
				<DialogContentText id="delete-account-description">
					{t("deleteAccountWarning")}
				</DialogContentText>

				<DialogContentText sx={{ mt: 2, fontWeight: 600 }}>
					{t("deleteAccountIrreversible")}
				</DialogContentText>

				<FormControlLabel
					sx={{ mt: 2 }}
					control={
						<Checkbox
							checked={confirmed}
							onChange={(e) => setConfirmed(e.target.checked)}
							color="error"
						/>
					}
					label={t("confirmDeleteAccount")}
				/>
			</DialogContent>

			<DialogActions>
				<Button onClick={onClose}>{t("cancel")}</Button>
				<Button
					variant="contained"
					color="error"
					onClick={handleDeleteAccount}
					disabled={!confirmed || isPending}
				>
					{t("deleteAccount")}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
